import { styled, TableSortLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { ArrowDropDownRounded } from '@mui/icons-material';
import { Box } from '@mui/system';
import { visuallyHidden } from '@mui/utils';

const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.background.paper2,
    color: theme.palette.text.primary,
    padding: theme.spacing(2),
  },
}));
function TableHeader(props: TableHeaderProps) {
  const { handleSelectAllClick, order, orderBy, numSelected, rowCount, handleRequestSort, configColumn, selectable } =
    props;
  const createSortHandler = (property: ExpectedAny) => (event: React.MouseEvent<unknown>) => {
    handleRequestSort(event, property);
  };

  return (
    <TableHead id="custom-table_header">
      <TableRow>
        {selectable && (
          <StyledHeaderCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={handleSelectAllClick}
              inputProps={{
                'aria-label': 'select all desserts',
              }}
            />
          </StyledHeaderCell>
        )}
        {configColumn.map((headCell, i) => (
          <StyledHeaderCell
            width={headCell.width}
            key={headCell.id + i}
            align={headCell.align || 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.disableSort ? headCell.label : <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              IconComponent={ArrowDropDownRounded}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>}

          </StyledHeaderCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default TableHeader;
